'use client';

import { usePathname } from 'next/navigation';
import * as React from 'react';

import { DOCKED_WATCHLIST_PREFIXES, isActive } from '@/components/layout/nav-config';
import { WatchlistDock } from '@/components/workspace/watchlist-dock';

/** The docked watchlist, on the trading pages only (hidden below lg). */
export function DockSlot(): React.ReactElement | null {
  const pathname = usePathname();
  const docked = DOCKED_WATCHLIST_PREFIXES.some((p) => isActive(pathname, p));
  return docked ? <WatchlistDock className="hidden lg:flex" /> : null;
}
